import { useTranslation } from "react-i18next"

import {
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

import { CustomersTableRow } from "./table-row"

export const TableHeaderContent = () => {
  const { t } = useTranslation()
  return (
    <TableHeader className="bg-zinc-200 hover:bg-zinc-300">
      <TableRow>
        <TableHead>
          {t("pages.customers.table.name")}
        </TableHead>
        <TableHead className="hidden lg:table-cell">
          ID
        </TableHead>
        <TableHead className="hidden lg:table-cell">
          {t("pages.customers.table.document")}
        </TableHead>
        <TableHead className="hidden lg:table-cell">
          {t("pages.customers.table.email")}
        </TableHead>
        <TableHead className="hidden lg:table-cell">
          {t("pages.customers.table.phone")}
        </TableHead>
        <TableHead className="hidden lg:table-cell">
          {t("pages.customers.table.createdAt")}
        </TableHead>
        <TableHead className="hidden lg:table-cell">
          {t("pages.customers.table.actions")}
        </TableHead>
      </TableRow>
    </TableHeader>
  )
}

type EmptyDataMessageProps = {
  colSpan: number
}

export const EmptyDataMessage = ({
  colSpan,
}: EmptyDataMessageProps) => {
  const { t } = useTranslation()
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        className="h-24 text-center"
      >
        {t("pages.customers.table.noCustomersFound")}
      </TableCell>
    </TableRow>
  )
}

type TableContentProps = {
  data: Customer[] | undefined
}

export const TableContent = ({
  data,
}: TableContentProps) => {
  if (!data || data.length === 0) {
    return <EmptyDataMessage colSpan={7} />
  }
  return (
    <>
      {data.map((customer) => (
        <CustomersTableRow
          key={customer.id}
          customer={customer}
        />
      ))}
    </>
  )
}
